import React, {Component} from "react";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {Tooltip, Table, Form, message, Col, Button, Modal, Input, Checkbox} from "antd";
import {settingOtodisApiService} from "../../services/otodis/SettingOtodisApiService";
import {CopyOutlined, FileImageOutlined, PlusSquareOutlined} from "@ant-design/icons";
import {WarehouseStates} from "./types/WarehouseTypes";
import AreaProvinceSelect from "../../components/area/AreaProvinceSelect";
import withAuth from "../../hoc/withAuth";
import AreaDistrictSelect from "../../components/area/AreaDistrictSelect";
import AreaCitySelect from "../../components/area/AreaCitySelect";
import AreaSubdistrictSelect from "../../components/area/AreaSubdistrictSelect";
import TextArea from "antd/es/input/TextArea";
import AreaCityMultiSelect from "../../components/area/AreaCityMultiSelect";

export interface WarehouseProps {
}

class Warehouse extends Component<WarehouseProps & any, WarehouseStates> {
    private readonly initState!: WarehouseStates;
    private tableColumn: any = [
        {
            title: "Kode Gudang",
            dataIndex: "warehouse_code",
            render: (value: string, row: []) => {
                return (
                    <React.Fragment>
                        <span className={`font-90`}>{value}</span>
                        &nbsp; &nbsp;
                        <Tooltip title="Click untuk copy kode gudang" color={"cyan"}>
                            <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)}/>
                        </Tooltip>
                    </React.Fragment>
                );
            },
        },
        {
            title: "Nama Gudang",
            dataIndex: "warehouse_name",
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>;
            },
        },
        {
            title: "Lokasi Gudang",
            dataIndex: "city_code",
            render: (value: string, row: any) => {
                return (
                    <>
                        <span className={`font-80`}>
                          {row.sub_district_name}, {row.district_name}, {row.city_name} {row.postal_code}
                        </span>
                    </>
                );
            },
        },
        {
            title: "PIC",
            dataIndex: "pic_name",
            render: (value: string, row: any) => {
                return <>
                    <span className={`font-80`}>{value?.toString()}&nbsp; <a target={"_blank"} rel={"noreferrer"} href={row.signature_image}><FileImageOutlined/></a></span>
                </>
            },
        },
        {
            title: "Covered City Area",
            dataIndex: "covered_area_city_name",
            render: (value: string) => {
                return <span className={`font-80`}>{value?.toString()}</span>;
            },
        },
        {
            title: "Alamat",
            dataIndex: "address",
            render: (value: string) => {
                return <span className={`font-80`}>{value}</span>;
            },
        }
    ];

    constructor(props: (WarehouseProps & any) | any) {
        super(props);

        this.initState = {
            processing: false,
            processingFetchTableData: true,
            dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
            dataWarehouse: [],
            pageSize: 500,
            modalAddWarehouse: false,
            addProcessing: false,

            countryCode: "idn",
            warehouseName: "",
            customerProvinceCode: "",
            customerProvinceName: "",
            customerCityCode: "",
            customerCityName: "",
            customerDistrictCode: "",
            customerDistrictName: "",
            customerSubdistrictCode: "",
            customerSubdistrictName: "",
            customerPostalCode: "",
            customerAddress: "",
            authorizedWarehouse: false,

            tempCoveredAreaCityCode: [],
            tempCoveredAreaCityName: [],
        };
        this.state = {...this.initState};
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
    };

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchTableData: true,
            dealerCode: data.value,
        });

        await this.fetchStockData();
    };

    fetchStockData = async () => {
        settingOtodisApiService
            .getWarehouse({
                dealerCode: this.state.dealerCode,
                active: true,
            })
            .then((dataFetchWarehouse) => {
                this.setState({
                    dealerCode: this.state.dealerCode,
                    dataWarehouse: dataFetchWarehouse.data.data,
                    processingFetchTableData: false,
                });
            })
            .catch(async (reason) => {
                await this.promisedSetState({
                    dataWarehouse: [],
                    processingFetchTableData: false,
                });
                message.error("Data Tidak Ditemukan");
            });
    };

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    };

    onAreaProvinceChange = (data: any) => {
        this.setState({
            customerProvinceCode: data.value,
            customerProvinceName: data.children,
            customerCityCode: "",
            customerCityName: "",
            customerDistrictCode: "",
            customerDistrictName: "",
            customerSubdistrictCode: "",
            customerSubdistrictName: "",
        });
    };

    onCoverAreaCityChange = (data: any) => {
        const tempCoveredAreaCityCode = [];
        const tempCoveredAreaCityName = [];
        for (const element of data) {
            if (element?.value) {
                tempCoveredAreaCityCode.push(element?.value);
                tempCoveredAreaCityName.push(element?.children);
            }
        }
        this.setState({
            tempCoveredAreaCityCode: tempCoveredAreaCityCode,
            tempCoveredAreaCityName: tempCoveredAreaCityName,
        });
    };

    onAreaCityChange = (data: any) => {
        this.setState({
            customerCityCode: data.value,
            customerCityName: data.children,
            customerDistrictCode: "",
            customerDistrictName: "",
            customerSubdistrictCode: "",
            customerSubdistrictName: "",
        });
    };

    onAreaDistrictChange = (data: any) => {
        this.setState({
            customerDistrictCode: data.value,
            customerDistrictName: data.children,
            customerSubdistrictCode: "",
            customerSubdistrictName: "",
        });
    };

    onAreaSubdistrictChange = (data: any) => {
        this.setState({
            customerSubdistrictCode: data.value,
            customerSubdistrictName: data.children,
            customerPostalCode: data.postalCode,
        });
    };

    onClickAdd = async () => {
        await this.promisedSetState({
            warehouseName: "",
            countryCode: Math.floor(+new Date())?.toString(),
            customerProvinceCode: "",
            customerProvinceName: "",
            customerCityCode: "",
            customerCityName: "",
            customerDistrictCode: "",
            customerDistrictName: "",
            customerSubdistrictCode: "",
            customerSubdistrictName: "",
            customerPostalCode: "",
            customerAddress: "",
            authorizedWarehouse: false,
            modalAddWarehouse: true,
            tempCoveredAreaCityCode: [],
            tempCoveredAreaCityName: [],
        });
    };

    onStringFieldChange = <T extends keyof Pick<any, "warehouseName" | "customerPostalCode" | "customerAddress" | "authorizedWarehouse">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "warehouseName":
                currentState.warehouseName = value;
                break;
            case "customerPostalCode":
                currentState.customerPostalCode = value;
                break;
            case "customerAddress":
                currentState.customerAddress = value;
                break;
            case "authorizedWarehouse":
                currentState.authorizedWarehouse = value;
                break;
        }

        this.setState({
            ...currentState,
        });
    };

    closeModalWarehouse = async () => {
        this.setState({
            modalAddWarehouse: false,
        });
    };

    okModalWarehouse = async () => {
        if (
            !this.state.dealerCode ||
            !this.state.tempCoveredAreaCityCode ||
            !this.state.warehouseName ||
            !this.state.customerAddress ||
            !this.state.customerProvinceCode ||
            !this.state.customerProvinceName ||
            !this.state.customerCityCode ||
            !this.state.customerCityName ||
            !this.state.customerDistrictCode ||
            !this.state.customerDistrictName ||
            !this.state.customerSubdistrictCode ||
            !this.state.customerSubdistrictName ||
            !this.state.customerPostalCode
        ) {
            Modal.error({
                title: "Proses Gagal",
                content: "Mohon Lengkapi Data",
            });
            return;
        }

        this.setState({
            addProcessing: true,
        });

        const input = [];
        input.push({
            dealer_code: this.state.dealerCode,
            name: this.state.warehouseName?.toUpperCase(),
            address: this.state.customerAddress?.toLowerCase(),
            province_code: this.state.customerProvinceCode,
            province_name: this.state.customerProvinceName,
            city_code: this.state.customerCityCode,
            city_name: this.state.customerCityName,
            district_code: this.state.customerDistrictCode,
            district_name: this.state.customerDistrictName,
            sub_district_code: this.state.customerSubdistrictCode,
            sub_district_name: this.state.customerSubdistrictName,
            postal_code: this.state.customerPostalCode,
            active: "true",
            authorized: this.state.authorizedWarehouse.toString(),
            covered_area_city_code: this.state.tempCoveredAreaCityCode,
            covered_area_city_name: this.state.tempCoveredAreaCityName,
        });

        try {
            await settingOtodisApiService.createNewWarehouse(input).then((successData) => {
                Modal.success({
                    title: "Proses Sukses",
                    content: "Data berhasil ditambahkan ",
                });
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            });
        } catch (e) {
            Modal.error({
                title: "Proses Gagal",
                content: "Server Menolak Inputan Anda :" + e,
            });
            await this.promisedSetState({
                addProcessing: false,
            });
        }
    };

    componentDidMount() {
        this.fetchStockData();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout
                    noPadNoMar={true}
                    onChangeDealer={this.onDealerChange}
                    breadcrumbPath={`Setting`}
                    breadcrumbMenu={`Gudang`}
                    defaultSelectedKeys={["m-setting-warehouse"]}
                    defaultOpenKeys={["sm-setting"]}
                >
                    <Col span={24} className={`pad-10`}>
                        <Form.Item>
                            <Button type={"primary"} icon={<PlusSquareOutlined/>} onClick={this.onClickAdd}>
                                Tambah Data
                            </Button>
                        </Form.Item>
                    </Col>

                    <Table
                        rowKey={"warehouse_code"}
                        size={"small"}
                        scroll={{x: "calc(500px + 50%)"}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumn}
                        dataSource={this.state.dataWarehouse}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />

                    <Modal
                        visible={this.state.modalAddWarehouse}
                        title="Tambah Gudang"
                        onOk={this.closeModalWarehouse}
                        onCancel={this.closeModalWarehouse}
                        cancelText={"Tutup"}
                        okText={false}
                        footer={[
                            <Button key="1" type="primary" loading={this.state.addProcessing} onClick={this.okModalWarehouse}>
                                Simpan
                            </Button>,
                            <Button key="2" type="primary" loading={this.state.addProcessing} onClick={this.closeModalWarehouse}>
                                Cancel
                            </Button>,
                        ]}
                    >
                        <Form layout={"vertical"}>
                            <Form.Item label="Nama Gudang">
                                <Input value={this.state.warehouseName} onChange={(event) => this.onStringFieldChange("warehouseName", event.target.value)} placeholder="Nama Gudang"/>
                            </Form.Item>
                            <Form.Item label="Provinsi">
                                <AreaProvinceSelect onAreaProvinceChangeProps={this.onAreaProvinceChange} country={this.state.countryCode}/>
                            </Form.Item>
                            <Form.Item label="Kota">
                                <AreaCitySelect onAreaCityChangeProps={this.onAreaCityChange} provinceCode={this.state.customerProvinceCode}/>
                            </Form.Item>
                            <Form.Item label="Covered Area Kota">
                                <AreaCityMultiSelect onAreaCityChangeProps={this.onCoverAreaCityChange} provinceCode={this.state.customerProvinceCode}/>
                            </Form.Item>
                            <Form.Item label="Kecamatan">
                                <AreaDistrictSelect onAreaDistrictChangeProps={this.onAreaDistrictChange} cityCode={this.state.customerCityCode}/>
                            </Form.Item>
                            <Form.Item label="Kelurahan">
                                <AreaSubdistrictSelect onAreaSubdistrictChangeProps={this.onAreaSubdistrictChange} districtCode={this.state.customerDistrictCode}/>
                            </Form.Item>
                            <Form.Item label="Kode Pos">
                                <Input value={this.state.customerPostalCode} onChange={(event) => this.onStringFieldChange("customerPostalCode", event.target.value)} placeholder="Kode Pos"/>
                            </Form.Item>
                            <Form.Item label="Alamat">
                                <TextArea
                                    value={this.state.customerAddress}
                                    onChange={(event) => this.onStringFieldChange("customerAddress", event.target.value)}
                                    placeholder="Alamat Gudang"
                                    autoSize={{minRows: 2}}
                                />
                            </Form.Item>
                            <Checkbox checked={this.state.authorizedWarehouse} onChange={(e) => this.onStringFieldChange("authorizedWarehouse", e.target.checked)}>
                                {" "}
                                <span className={`divider-stock-purchase`}> Gudang Resmi </span>{" "}
                            </Checkbox>
                        </Form>
                    </Modal>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default withAuth(withRouter(Warehouse), 16);
